const { TYPE_MASTER_ADMIN, TYPE_SUPER_ADMIN, TYPE_ADMIN } = require('./constants');

/**
 * Check user is admin or not
 * @param user
 * @return Boolean
 */
const isAdmin = (user) => user.kind === TYPE_ADMIN || isSuperAdmin(user);

const isSuperAdmin = (user) => user.kind === TYPE_SUPER_ADMIN || isMasterAdmin(user);

const isMasterAdmin = (user) => user.kind === TYPE_MASTER_ADMIN;

module.exports = { isAdmin, isSuperAdmin, isMasterAdmin };



//////////////////
// WEBPACK FOOTER
// ./utils/isAdmin.js
// module id = V9jL
// module chunks = 1